<template>
	<v-app id="app" :class="homePage() ? 'homepage' : 'inpage'">
		<DataPrivacy v-if="showDPDialog" />
		<div v-if="$store.state.active_loader" class="loader-wrapper" :style="{ 'background-color': $store.state.active_loader ? 'rgba(0, 0, 0, .7)' : '' }">
			<GridLoader :loading="$store.state.active_loader" :height="35" :width="4" :radius="2" :color="'#e60000'" :margin="'5px'" />
		</div>
		<v-toolbar id="toolbar" class="toolbar" dark color="primary" app>
			<div class="d-flex flex-nowrap" style="align-items: center">
				<div class="menu-icon-toggle" @click="sideNav = !sideNav"></div>
				<div class="bashkia-logo" style="margin-left: 15px" v-on:click="openBashkiaHomePage()"></div>
			</div>
			<div @click="goTo({ name: 'home' })" class="tirana-ime-logo" style="margin-right: 41px"></div>
			<!-- <div v-if="showbetalabel == 'true'" class="beta-label">Beta V2.0</div> -->
			<div @click="toggleVodIframe()" class="vodafone-logo"></div>
		</v-toolbar>
		<v-navigation-drawer app class="sidebar" v-model="sideNav" :touchless="$vuetify.breakpoint.lgAndUp">
			<img class="sidebar-bg" src="./assets/img/sidebar-test.png" alt />
			<div class="sidebar-header">
				<div class="sidebar-header-tirana" v-on:click="goTo({ name: 'home' })"></div>
				<div class="sidebar-header-bashkia" v-on:click="openBashkiaHomePage()"></div>
			</div>
			<div class="sidbar-middle d-flex">
				<div>Tirana ime</div>
				<v-spacer></v-spacer>
				<v-btn-toggle v-model="lang" class="lang-toggle" active-class="active-lang">
					<v-btn small outline class="lang-toggle-item" active-class="active-lang">SQ</v-btn>
					<v-btn small outline class="lang-toggle-item" active-class="active-lang">EN</v-btn>
				</v-btn-toggle>
			</div>
			<v-list class="sidebar-list-wrapper" dense>
				<SideMenuElement v-for="item in comming_routes" :key="item.name" :menuItemToPresent="item" />
			</v-list>
		</v-navigation-drawer>
		<v-content class="content-wrapper" id="main_content" v-touch:swipe="swipeUp">
			<div class="content-bg-top"></div>
			<img class="content-bg lazyload" src="./assets/img/content-test.png" alt />
			<HomeDashboard id="home" v-if="homePage()" />
			<transition-group name="router-animation" mode="out-in">
				<router-view :key="'transition-router-view'" id="element" v-touch:swipe="swipeUp"></router-view>
			</transition-group>
		</v-content>
		<BaseFooterTabsNavigation v-if="!homePage()" />
	</v-app>
</template>

<script>
import { VODAFONE_URL, BASHKIA_TIRANE_URL } from '@/config/api/url/urls_in_app';
import { GridLoader } from '@saeris/vue-spinners';
import comming_routes from '@/config/router_array/routes';
import SideMenuElement from '@/components/menu/SideMenuElement';
import HomeDashboard from '@/components/home/HomeDashboard';
import settings from '@/config/api/api_events/settings';
import user from '@/config/api/api_events/user';
// import firebase from "firebase/app";
// import "firebase/messaging";
import native_capacitor from '@/config/js_helper/native_capacitor';
import md5_user_id from '@/config/js_helper/md5_user_id.js';
// import firebase_config from "../firebase_config";
import DataPrivacy from '@/components/home/DataPrivacy';

if (!localStorage.getItem('locationalerts')) {
	localStorage.setItem('locationalerts', false);
}
if (!localStorage.getItem('storagealerts')) {
	localStorage.setItem('storagealerts', false);
}

export default {
	name: 'AppEntry',
	components: {
		SideMenuElement,
		HomeDashboard,
		GridLoader,
		DataPrivacy,
	},
	data() {
		return {
			sideNav: false,
			right: false,
			left: false,
			comming_routes: [],
			watch_route: null,
			showbetalabel: process.env.VUE_APP_SHOW_BETA_LABEL,
			togglelang: 0,
		};
	},
	computed: {
		showDPDialog() {
			return this.$root.showDPDialog;
		},
		lang: {
			get() {
				return this.$store.state.type_language - 1;
			},
			set(langval) {
				if (!this.$vuetify.breakpoint.lgAndUp) {
					this.sideNav = false;
				}
				this.$store.commit('setNewLanguageType', langval + 1);
			},
		},
	},
	beforeCreate() {
		native_capacitor.addPhoneBackButtonListerner();
	},
	created() {
		if (this.$vuetify.breakpoint.lgAndUp) {
			this.sideNav = true;
		}
		this.getItemFromRoutes();
		this.$store.state.active_loader = true;
		native_capacitor.getPhoneIdForReport().then((res) => {
			//console.log(res)
			// Initialize Firebase if we are in web platform
			/* if (!this.$root.firebaseinited && res.platform === 'web') {
				native_capacitor.initializeFirebase()
				this.$root.firebaseinited = true
			} else {
				this.$root.firebaseinited = true
			} */
			native_capacitor.getPhoneId().then((userid) => {
				user.createUser('0', res.platform, res.osVersion, md5_user_id.getUserMd5Id(userid.uuid)).then((response) => {
					if (response.excluded) {
						localStorage.setItem('excluded', JSON.stringify(response.excluded));
					} else {
						localStorage.removeItem('excluded');
					}
				});
				localStorage.setItem('user_id', md5_user_id.getUserMd5Id(userid.uuid));
			});
		});
		this.$store.state.active_loader = false;
		// console.log(token); // Receiver Token to use in the notification
		// })
		// .catch(err => {
		//   console.log("Unable to get permission to notify.", err);
		// });
	},
	methods: {
		openBashkiaHomePage() {
			native_capacitor.openUrl(BASHKIA_TIRANE_URL);
		},
		goTo(place) {
			this.$router.push(place);
		},
		startFrom(array, idx) {
			return array.slice(idx);
		},
		homePage() {
			return this.$route.path == '/';
		},
		swipeUp(direction) {
			if (this.$route.path == '/') {
				var headerHeight = document.getElementById('toolbar').offsetHeight;
				var windowInnerHeight = window.innerHeight;
				var scrollY = window.scrollY;

				if (direction == 'top' && scrollY < windowInnerHeight - headerHeight) {
					window.scrollTo({
						top: windowInnerHeight - headerHeight,
						behavior: 'smooth',
					});
				} else if (direction == 'bottom' && scrollY <= windowInnerHeight) {
					window.scrollTo({
						top: 0,
						behavior: 'smooth',
					});
				}
			}
		},
		toggleVodIframe() {
			native_capacitor.openUrl(VODAFONE_URL);
		},
		getItemFromRoutes() {
			this.comming_routes = comming_routes.filter((el) => {
				return el.isNavgationBar;
			});
		},
	},
};
</script>

<style lang="scss" src="./app.scss"></style>
